function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_313",
  "data-name": "Group 313",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  d: "M897.42,559.6a10.258,10.258,0,0,1-2.521.719c.406-.068,1-.8,1.244-1.1a4.64,4.64,0,0,0,.839-1.529c.022-.043.038-.1-.005-.131a.142.142,0,0,0-.133.011,12.863,12.863,0,0,1-2.994,1.146.2.2,0,0,1-.206-.055,2.433,2.433,0,0,0-.262-.267,5.3,5.3,0,0,0-1.451-.889,5.052,5.052,0,0,0-2.225-.359,5.331,5.331,0,0,0-2.11.6,5.436,5.436,0,0,0-1.7,1.391,5.24,5.24,0,0,0-1.018,2.036,5.511,5.511,0,0,0-.053,2.15c.016.12.005.137-.1.12a15.991,15.991,0,0,1-10.289-5.237c-.12-.136-.185-.136-.284.011a5.219,5.219,0,0,0,.89,6.164c.2.191.409.382.632.556a5.226,5.226,0,0,1-1.985-.556c-.12-.076-.181-.032-.191.1a3.109,3.109,0,0,0,.032.59,5.277,5.277,0,0,0,3.252,4.206,3.059,3.059,0,0,0,.66.2,5.878,5.878,0,0,1-1.947.06c-.142-.027-.2.044-.142.18a5.477,5.477,0,0,0,4.092,3.426c.185.032.371.032.557.076-.012.016-.023.016-.033.033-.46.7-2.053,1.221-2.794,1.481a10.011,10.011,0,0,1-4.244.543c-.228-.034-.276-.031-.338,0s-.008.093.066.152c.29.191.584.361.883.524a14.041,14.041,0,0,0,2.837,1.135,15.111,15.111,0,0,0,14.669-3.43c3.005-2.987,4.059-7.106,4.059-11.229,0-.162.191-.251.3-.336a9.888,9.888,0,0,0,1.987-2.076.605.605,0,0,0,.123-.4V559.6C897.514,559.536,897.522,559.557,897.42,559.6Z",
  transform: "translate(-872.559 -557.139)",
  fill: "#213368"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_314",
  "data-name": "Group 314",
  transform: "translate(7.411 20.467)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  d: "M882.006,583.228Z",
  transform: "translate(-882.006 -583.228)",
  fill: "#213368",
  fillRule: "evenodd"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_315",
  "data-name": "Group 315",
  transform: "translate(7.221 20.467)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M881.954,583.228c-.033,0-.412,0,0,0Z",
  transform: "translate(-881.763 -583.228)",
  fill: "#213368",
  fillRule: "evenodd"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_316",
  "data-name": "Group 316",
  transform: "translate(8.252 20.47)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M883.077,583.251c0-.042.442,0,0,0C883.077,583.229,883.131,583.251,883.077,583.251Z",
  transform: "translate(-883.077 -583.232)",
  fill: "#213368",
  fillRule: "evenodd"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_317",
  "data-name": "Group 317",
  transform: "translate(16.975 0.03)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_54",
  "data-name": "Path 54",
  d: "M894.3,557.177a.088.088,0,0,1-.1,0Z",
  transform: "translate(-894.197 -557.177)",
  fill: "#213368",
  fillRule: "evenodd"
}));

var SvgIconTwitter = function SvgIconTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_318",
    "data-name": "Group 318",
    width: 24.956,
    height: 20.555,
    viewBox: "0 0 24.956 20.555",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconTwitter.65de06dd.svg";
export { ForwardRef as ReactComponent };